import { render, staticRenderFns } from "./EditdeliverydatePage.vue?vue&type=template&id=b7183418"
import script from "./EditdeliverydatePage.vue?vue&type=script&lang=js"
export * from "./EditdeliverydatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports